import {Component, Input, OnInit} from '@angular/core';
import { ClassificatorEditModalComponent } from '../classificator-edit-modal/classificator-edit-modal.component';
import { ControlContainer, NgForm } from '@angular/forms';
import { SelectComponent } from '../../../core/components/edit-component';
import {ClassificatorsQuery, ClassificatorValueQuery} from 'common-shared';
import {map} from "rxjs/operators";
import {instanceToInstance} from "class-transformer";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  selector: 'mes-web-classificator-value-select',
  templateUrl: './classificator-value-select.component.html',
  styleUrls: ['./classificator-value-select.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class ClassificatorValueSelectComponent extends SelectComponent<ClassificatorValueQuery> implements OnInit {
  @Input() classificatorId: string;
  @Input() isInvalid: boolean = false;
  @Input() dropDownCssClass = 'dropdown-auto-width'

  constructor(public classificatorsQuery: ClassificatorsQuery, public sanitizer: DomSanitizer) {
    super();
  }

  ngOnInit() {
    this.allItems$ = this.allItems$.pipe(map(clvs => {
      const copiedClvs = instanceToInstance(clvs);
      // @ts-ignore
      copiedClvs.map(clv => clv.disabled = clv.IsDisabled);
      return copiedClvs;
    }));
  }

  editExisting(item: ClassificatorValueQuery) {
    this.modalService.show(ClassificatorEditModalComponent, {
      initialState: {
        classificatorId: item.ClassificatorId,
        classificatorValueId: this.entityId
      }, class: 'modal-lg'
    }).onHide$.subscribe((bsModalRef) => {
      const comp = bsModalRef.content;
      this.setEntityId(comp.classificatorValueId);
    });
  }

  addNewClassificatorValue(searchTerm: string = null) {
    this.allItems$.subscribe(values => {
      this.modalService.show(ClassificatorEditModalComponent, {
        initialState: {
          classificatorValueName: searchTerm,
          classificatorId: this.classificatorId || (values[0] || { ClassificatorId: null }).ClassificatorId
        }, class: 'modal-lg'
      }).onHide$.subscribe((bsModalRef) => {
        if (bsModalRef.content.classificatorValueId) {
          this.setEntityId(bsModalRef.content.classificatorValueId);
        }
      });
    });
  }

  onSelectionChanged($event: ClassificatorValueQuery[] | ClassificatorValueQuery) {
    if (this.multiple) {
      const clvs = $event as ClassificatorValueQuery[];
      if (clvs && clvs.length) {
        this.entityIdsChange.emit(clvs.map(value => value.Id));
      } else {
        this.entityIdsChange.emit([]);
      }
    } else {
      this.entityChange.emit($event as ClassificatorValueQuery);
      this.entityIdChange.emit(($event as ClassificatorValueQuery)?.Id);
    }
  }
}
